import { Component, ViewChild } from '@angular/core';
import {
  cardClickEvent,
  mppRecipeCard,
} from '@app/mpp/model/recipe-card-model';
import { recipeMPPViewModel } from '@app/mpp/model/recipe-mpp-view-model';
import { MppService } from '@app/mpp/service/mpp.service';
import { ViewWillEnter } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { MPPMenuItem } from '@usf/ngrx-tools/lib/model/mpp-menu-item';
import { Observable, filter, take, tap } from 'rxjs';
import { RecipeService } from './services/recipe.service';
import { SortableSectionHeader } from '@shared/components/sortable-section/models/sortable-section.model';
import { SortFilterMppModalContainerComponent } from '@app/mpp/shared/components/modal/sort-filter-mpp-modal-container/sort-filter-mpp-modal-container.component';
import { RecipeModalSortOptions } from '@app/mpp/model/modal-values';
import { CopyRecipeCreateModalComponent } from '../../shared/components/modal/copy-recipe-create-modal/copy-recipe-create-modal.component';
import { Recipe } from '@usf/mpp-types';
import { ArchiveRecipe } from '@usf/ngrx-tools/lib/model/recipe';
import { PATHS } from '@shared/constants/paths';

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.page.html',
  styleUrls: ['./recipes.page.scss', '../../styles/shared-mpp-styles.scss'],
})
export class RecipesPage implements ViewWillEnter {
  currentPage = 'i18n.menuProfitPro.links.recipes';
  viewModel$: Observable<recipeMPPViewModel>;
  deleteModalOpen: boolean[];
  @ViewChild(SortFilterMppModalContainerComponent) sortFilterModal;
  createMppModalOpen: boolean[];
  createRecipeTitle = 'i18n.menuProfitPro.createModal.titleRecipe';
  defaultCreateMppSelction = 'recipe';
  @ViewChild(CopyRecipeCreateModalComponent)
  copyRecipeModal: CopyRecipeCreateModalComponent;

  constructor(
    public mppService: MppService,
    readonly platformService: PlatformService,
    private panAppState: PanAppState,
    readonly translateService: TranslateService,
    public recipeService: RecipeService,
  ) {
    this.viewModel$ = this.mppService.recipeMPPViewModel;
  }

  ionViewWillEnter(): void {
    this.mppService.enterRecipe();
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.mppRecipes),
    );
    this.clearAllFiltersSort();
    this.recipeService.deselectSelections();
  }

  gotoRequest(item: MPPMenuItem) {
    if (item.goTo === PATHS.MANAGE_NON_USF_PRODUCTS) {
      this.mppService.goToPageWithinMPP(
        item.goTo,
        this.translateService.instant(this.currentPage),
      );
    } else {
      this.mppService.goToPageWithinMPP(item.goTo);
    }
  }

  goToDetails(recipeId: string) {
    this.mppService.enterRecipeDetails(true, false);
    this.mppService.goToDetails(recipeId);
  }

  handleOnRecipeClick(item: mppRecipeCard) {
    this.recipeService.selectRecipe(item.recipeId);
  }

  handleOnEllipsisClick(event: cardClickEvent, recipes: mppRecipeCard[]) {
    const buttons = this.recipeService.getRecipeActionButtons(
      event,
      recipes,
      this.copyRecipeModal,
    );
    if (
      this.platformService.platformType ===
      this.platformService.platformEnum.desktop
    ) {
      this.recipeService.showEllipsisOptionsDesktop(buttons);
    } else {
      this.recipeService.showEllipsisOptionsTouch(buttons);
    }
  }

  handleDelteConfirmationDismiss() {
    this.recipeService.deleteModalIsOpen = false;
  }

  handlCopyRecipeCreation(recipe: Recipe) {
    this.recipeService.copyRecipeSameCustomerAction(recipe);
  }

  handleDeleteConfirmationSubmission(recipeIds: string[]) {
    this.recipeService.deleteRecipesFromState(recipeIds);
    this.handleDelteConfirmationDismiss();
  }

  trackItem(index: number, item: mppRecipeCard) {
    return item ? item?.recipeId : index;
  }

  updateSort(sortableSectionHeader: SortableSectionHeader) {
    this.recipeService.selectHeader(sortableSectionHeader);
  }

  handleSelectAll(items: mppRecipeCard[], everythingSelected: boolean) {
    if (everythingSelected) {
      this.recipeService.deSelectMultiple(items.map(item => item.recipeId));
    } else {
      this.recipeService.selectMulitple(items.map(item => item.recipeId));
    }
  }

  handleBulkDelete(items: mppRecipeCard[]) {
    this.recipeService.actionBySelection = true;
    this.recipeService.openDeleteRecipesModal(
      items.map(item => item.recipeId),
      items,
    );
  }
  handleBulkArchive(items: mppRecipeCard[], filterArchive: boolean) {
    this.recipeService.actionBySelection = true;
    let recipeIds: string[] = items.map(item => item.recipeId);
    const archiveRecipe: ArchiveRecipe = {
      recipeIds,
      isArchive: filterArchive,
    };
    this.recipeService.archiveRecipesAction(archiveRecipe);
  }

  openSortModal() {
    this.sortFilterModal.openModal();
  }

  handleModalSubmission = (submitMap: Map<string, any | any[]>) => {
    if (submitMap.has('group')) {
      this.recipeService.updateGroupFilter(
        submitMap.get('group').map(item => item.value),
      );
    }
    if (submitMap.has('status')) {
      this.recipeService.updateFilterArchive(
        submitMap.get('status') === 'true' || submitMap.get('status') === true,
      );
    }
    if (submitMap.has('sort')) {
      this.recipeService.directlyUpdateSort(submitMap.get('sort'));
    }
    this.recipeService.deselectSelections();
  };

  clearAllFiltersSort() {
    this.recipeService.deselectSelections();
    this.recipeService.updateGroupFilter([]);
    this.recipeService.updateFilterArchive(true);
    this.recipeService.directlyUpdateSort(RecipeModalSortOptions.RecipeAZ);
    this.recipeService.updateSearchFilter('');
  }

  search(searchKey: string) {
    this.recipeService.updateSearchFilter(searchKey);
  }
}
